import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingDeadlines = ({ deadlines, onViewTask }) => {
  const getDaysUntilDue = (dueDate) => {
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getUrgencyColor = (daysUntil) => {
    if (daysUntil < 0) return 'text-error bg-error/10 border-error/20';
    if (daysUntil === 0) return 'text-warning bg-warning/10 border-warning/20';
    if (daysUntil <= 2) return 'text-warning bg-warning/10 border-warning/20';
    if (daysUntil <= 7) return 'text-accent bg-accent/10 border-accent/20';
    return 'text-success bg-success/10 border-success/20';
  };

  const getUrgencyText = (daysUntil) => {
    if (daysUntil < 0) return `${Math.abs(daysUntil)} days overdue`;
    if (daysUntil === 0) return 'Due today';
    if (daysUntil === 1) return 'Due tomorrow';
    return `Due in ${daysUntil} days`;
  };

  const sortedDeadlines = deadlines?.sort((a, b) => {
    const daysA = getDaysUntilDue(a?.dueDate);
    const daysB = getDaysUntilDue(b?.dueDate);
    return daysA - daysB;
  });

  return (
    <div className="bg-card border border-border rounded-lg card-shadow">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Upcoming Deadlines</h3>
        <Icon name="Calendar" size={20} className="text-muted-foreground" />
      </div>
      <div className="max-h-80 overflow-y-auto">
        {sortedDeadlines?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Calendar" size={32} className="mx-auto text-muted-foreground mb-2" />
            <p className="text-sm text-muted-foreground">No upcoming deadlines</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {sortedDeadlines?.map((deadline) => {
              const daysUntil = getDaysUntilDue(deadline?.dueDate);
              return (
                <div key={deadline?.id} className="p-4 hover:bg-muted/50 transition-smooth">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="text-sm font-medium text-foreground line-clamp-1">
                      {deadline?.title}
                    </h4>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium border ml-2 ${getUrgencyColor(daysUntil)}`}>
                      {getUrgencyText(daysUntil)}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2 line-clamp-2">
                    {deadline?.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3 text-xs text-muted-foreground">
                      <div className="flex items-center space-x-1">
                        <Icon name="FolderOpen" size={12} />
                        <span>{deadline?.project}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Calendar" size={12} />
                        <span>{new Date(deadline.dueDate)?.toLocaleDateString()}</span>
                      </div>
                    </div>
                    <Button
                      variant="ghost"
                      size="xs"
                      iconName="ArrowRight"
                      onClick={() => onViewTask(deadline?.id)}
                    >
                      View
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingDeadlines;